import Chart from 'chart.js/auto';

(function (Drupal, once) {

    Drupal.behaviors.lifewatchCustomchart = {

        attach: function (context, settings) {
            const pubchartItems = once('lwPubchart', '#publications', context);
            pubchartItems.forEach((item)=> {
                getPubData().then(pubData => {
                  if(JSON.stringify(pubData) !== "{}") {
                    const groupedByPubDate = Object.groupBy(pubData, ({ PubDate }) => PubDate);
                    new Chart(
                      item,
                      {
                        type: 'bar',
                        data: {
                          labels: Object.keys(groupedByPubDate),
                          datasets: [
                            {
                              label: 'Publications by year',
                              data: Object.values(groupedByPubDate).map(row => row.length)
                            }
                          ]
                        }
                      }
                    );
                  }
                });
            });
        }
    };
}(Drupal, once));

const getPubData = async function () {
    const base_url = window.location.origin;
    const url = base_url + "/en/imis?module=ref&searchspcollist=897,896,919,942,793,880,915&show=json";
    try {
        const response = await fetch(url);
        if (!response.ok) {
            throw new Error(`Response status: ${response.status}`);
        }

        const json = await response.json();
        return json;
    } catch (error) {
        console.error(error.message);
        return {};
    }
};

